import type { FC } from "react";
import { isString } from "@huub-web/utils";

import { Button } from "../Button/Button";
import type { UserPromptRecord } from "../../types";
import { Badge, type BadgeProps } from "../Badge/Badge";
import type { IconName } from "../../theme";
import { Icon } from "../Icon/Icon";

export type SuggestionProps = {
  suggestion: UserPromptRecord;
  disabled?: boolean;
  badge?: BadgeProps["value"];
  icon?: IconName;
  variant?: "canvas" | "sideContent";
  onClick?: (suggestion: UserPromptRecord) => void;
};

/**
 * A component that displays suggested content or actions to the user
 */
export const Suggestion: FC<SuggestionProps> = ({
  suggestion,
  badge,
  icon = "aiFilled",
  disabled = false,
  variant = "sideContent",
  onClick,
}: SuggestionProps) => (
  <Button
    variant={variant === "canvas" ? "primary" : "background"}
    disabled={disabled}
    onClick={() => onClick?.(suggestion)}
    size="s"
    leading={icon && <Icon icon={icon} size="s2" color="inputBorderFocus" />}
    trailing={
      badge && (
        <Badge value={badge} offset="medium" variant="accent" inline size="s" />
      )
    }
  >
    {isString(suggestion) ? suggestion : suggestion.display}
  </Button>
);
